import { usePage } from "@hooks/usePage";
import MapView from "../components/MapView";
import TableView from "../components/TableView";
import ReleasesFilter from "../components/ReleasesFilter";
import ModalNewRelease from "../components/ModalNewRelease";
import { useEffect } from "react";
import { useReleasesFilters } from "@hooks/releases/useReleasesFilters";

function ManagingReleasesScreen() {
  const { viewMode } = usePage();

  const {
    filters,
    appliedFilters,
    handleChange: handleFilterChange,
    apply: applyFilters,
    reset: resetFilters,
  } = useReleasesFilters();

  useEffect(() => {
    resetFilters();
  }, [viewMode, resetFilters]);

  return (
    <div className="space-y-6">
      <ReleasesFilter
        filters={filters}
        onChange={handleFilterChange}
        onApply={applyFilters}
      />

      {viewMode === "map" ? (
        <MapView appliedFilters={appliedFilters} />
      ) : (
        <TableView appliedFilters={appliedFilters} />
      )}

      <ModalNewRelease />
    </div>
  );
}

export default ManagingReleasesScreen;
